var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.pay()}}},[_vm._v(" Pay "),_c('money-string',_vm._b({},'money-string',_vm.$props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }